import API from 'services/api';
import axios from 'axios';
import {
  DigitalWalletProvider,
  APPLE_PAY_ALLOWED_NETWORKS,
  DEFAULT_CARD_NETWORKS_SUPPORTED,
  DEFAULT_APPLE_PAY_VERSION
} from 'consts';
import { encodeBase64, isIframe } from 'utilities/global';
import { sendParentMessage } from 'services/iframeService';
import { getSupportedPaymentMethodTypeNetworks } from 'services/digitalWalletProvider/shared';

export const validateMerchantSession = async ({
  pageToken,
  validationURL,
  domainName
}) => {
  let session;

  try {
    const response = await API.post('hosted/apple/validate-session', {
      checkout: pageToken,
      appleUrl: validationURL,
      domainName: domainName || window.location.hostname,
      displayName: 'Checkout'
    });
    session = response.data.data.session;
  } catch (err) {}

  return session;
};

export const isApplePaySupported = () => {
  if (!window.ApplePaySession || window.location.protocol !== 'https:') return false;

  if (isIframe()) {
    sendParentMessage('INIT_DIGITAL_PROVIDERS', {
      applePayVersion: DEFAULT_APPLE_PAY_VERSION
    });
    return;
  }

  return (
    window.ApplePaySession.canMakePayments() &&
    window.ApplePaySession.supportsVersion(DEFAULT_APPLE_PAY_VERSION)
  );
};

export const initializeSession = ({ applePayVersion, paymentRequest }) => {
  return new window.ApplePaySession(applePayVersion, paymentRequest);
};

export const initializeSessionObject = ({
  applePayVersion = DEFAULT_APPLE_PAY_VERSION,
  merchantReferenceId,
  cardPaymentMethodTypes,
  total,
  totalCurrency,
  country
}) => {
  const additionalData = JSON.stringify({ merchant_reference_id: merchantReferenceId });
  let supportedNetworks = getSupportedPaymentMethodTypeNetworks({
    paymentMethodTypes: cardPaymentMethodTypes,
    allowedNetworks: APPLE_PAY_ALLOWED_NETWORKS
  });
  if (!supportedNetworks || !supportedNetworks.length) {
    supportedNetworks = DEFAULT_CARD_NETWORKS_SUPPORTED;
  }

  return {
    applePayVersion,
    paymentRequest: getPaymentRequest({
      total,
      currency: totalCurrency,
      country,
      supportedNetworks,
      additionalData
    })
  };
};

const getPaymentRequest = ({
  total,
  currency,
  country,
  supportedNetworks,
  additionalData
}) => {
  const request = {
    countryCode: country,
    currencyCode: currency,
    supportedNetworks,
    merchantCapabilities: ['supports3DS'],
    total,
    additionalData: encodeBase64(additionalData)
  };

  return request;
};

export const formatApplePayDataToPayment = ({ paymentData }) => {
  return {
    type: DigitalWalletProvider.APPLE_PAY,
    details: paymentData
  };
};
